export default{
    msg:'',
    editar:{},
    lista:'',
    pesquisa:'',
    boletins:'',
    taxas:'',
    fatura_id:'',
    rublucas:'',
    trabalhadores:''
}